import { IHttpResponse, IHttpService, ILocationService, IQService } from "angular";
import { HALResponse } from 'ng/src/app/shared/model/app.model';
import { handleFormError } from "../../assets/js/misc";
import { ErrorMessage } from "../shared/model/properties.model";
import { ChoiceList } from "ng/src/app/choice-lists/shared/choice-list.model";

angular.module('logbook')
	.directive('choiceListList', ['$http', '$location', '$q',
		($http: IHttpService, $location: ILocationService, $q: IQService) => {
			return {
				restrict: 'E',

				scope: {
					selectedLog: '='
				},

				template: require('./choice-list-list.html'),

				link: (scope) => {
					scope.copyDialogVisible = false;
					scope.copyingList = null;
					scope.refreshChoiceLists = () => {
						$http.get<HALResponse<{ choiceLists: ChoiceList[] }>>('api/choiceLists', {
							headers: {
								'X-LogBook-Flags': 'disable-query-cache'
							},
							params: {
								'log': scope.selectedLog.id
							}
						})
						.then(result => {
							scope.choiceLists = result.data._embedded.choiceLists;

							let listId = parseInt($location.search()['editList']);

							if (!isNaN(listId))
								scope.doEditChoiceList(scope.choiceLists.find((list: ChoiceList) => list.id === listId));
						});
					};

					scope.refreshChoiceLists();

					scope.doEditChoiceList = (list: ChoiceList) => {
						if (!list)
							return;

						scope.editChoiceList = list;
						scope.oldEditList = list.id;

						$location.search('editList', list.id);
					};

					scope.deleteChoiceList = (choiceList: ChoiceList) => {
						$http.delete(choiceList._links.self.href).then(() => {
							scope.refreshChoiceLists();
						});
					};

					scope.resetNewChoiceList = () => {
						scope.newChoiceList = {};
					};

					scope.setNewChoiceListField = (field: 'newChoiceListName', $data: string) => {
						scope.newChoiceList[field] = $data;
					};

					scope.getChoiceListCheckRequest = (listName: string) => {
						return $http.get('api/choiceLists',
							{
								params: {
									log: scope.selectedLog.id,
									name: listName,
									size: 1
								},
								noErrorPopup: true
							})
					};

					scope.addChoiceList = () => {
						let d = $q.defer();

						scope.getChoiceListCheckRequest(scope.newChoiceList.newChoiceListName)
							.then((response: IHttpResponse<HALResponse<{ choiceLists: ChoiceList[] }>>) => {

								// Verify no choice lists exist with same name
								if (response.data._embedded.choiceLists.length > 0) {
									handleFormError(d, scope.newChoiceListForm, [{
										property: 'name',
										message: 'List ' + scope.newChoiceList.newChoiceListName + ' already exists.'
									}]);
									return;
								}

								let config = {
									noErrorPopup: true,
									rawError: true
								};

								return $http.post('/api/choiceLists', {
									name: scope.newChoiceList.newChoiceListName,
									log: scope.selectedLog._links.self.href
								}, config);
							})
							.then(
								() => {
									scope.refreshChoiceLists();
									d.resolve();
								},
								(errors: ErrorMessage) => {
									handleFormError(d, scope.newChoiceListForm, errors);
								}
							);

						return d.promise;
					};

					scope.getDirectListUrl = (list: ChoiceList) => {
						return '/#' + $location.url() + '&editList=' + list.id;
					};
					
					scope.startToCopyList = (list: ChoiceList) => {
						scope.copyingList = list;
						scope.copyDialogVisible = !!list;
					}

					scope.$on('$locationChangeSuccess', () => {
						let val = $location.search()['editList'];
						if (val === scope.oldEditList)
							return;

						val = parseInt(val);

						let list = (Array.isArray(scope.choiceLists) && !isNaN(val))
							? scope.choiceLists.find(list => list.id === val)
							: undefined;

						if (list)
							scope.doEditChoiceList(list);
						else
							delete scope.editChoiceList;
					});

					scope.$on('$destroy', () => {
						$location.search('editList', null);
					});
				}
			}
		}
	]);